import React, { useEffect, useState } from 'react';
import { Alert, Button, CircularProgress, Paper } from '@mui/material';

import { GableSettings } from '@paragon/contract-library';
import { PropertiesPanel } from '@paragon/layout-models';

import { getDefaultGableSettings } from '../../../../library/profiles/profileTrussDefaults';
import { gable } from '../../../../store/actions/editorActions';
import { __UNSAFE_loadProfileDefaultsUsingProjectGuidOrFallback } from '../../../../store/actions/loadActions';
import { setTrussEditsPanel } from '../../../../store/slices/panelDataSlice';
import { useAppDispatch } from '../../../hooks';
import { GableSettingsSubPanel } from '../../subpanels/properties/GableSettings';

export function MakeGablePanel() {
  const dispatch = useAppDispatch();

  const [gableSettings, setGableSettings] = useState<null | 'error' | GableSettings>(null);

  useEffect(() => {
    dispatch(__UNSAFE_loadProfileDefaultsUsingProjectGuidOrFallback())
      .then((defaults) => {
        setGableSettings(getDefaultGableSettings(defaults, { isGable: true }));
      })
      .catch((error) => {
        console.error(error);
        setGableSettings('error');
      });
  }, [dispatch]);

  return (
    <PropertiesPanel title="Make Gable">
      {gableSettings == null ? (
        <CircularProgress />
      ) : gableSettings === 'error' ? (
        <Alert variant="outlined" severity="error">
          Unable to load profile defaults. Please try again or contact Paragon Customer Support.
        </Alert>
      ) : (
        <GableSettingsSubPanel hideGableCheckbox value={gableSettings} onChange={setGableSettings} />
      )}

      <Paper elevation={1} sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end', p: 1, borderRadius: 0 }}>
        <Button
          variant="outlined"
          onClick={() => {
            dispatch(setTrussEditsPanel(null));
          }}
          aria-label="Close"
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          disabled={gableSettings === null || gableSettings === 'error'}
          onClick={() => {
            if (gableSettings == null || gableSettings === 'error') throw new Error('invalid state');

            dispatch(setTrussEditsPanel(null));
            dispatch(gable(gableSettings));
          }}
        >
          Make Gable
        </Button>
      </Paper>
    </PropertiesPanel>
  );
}
